import * as React from 'react';
import { FC } from 'react';
import { style } from 'typestyle';

const Header: FC<{ isMobile: boolean; text: string }> = ({ isMobile, text }) => (
  <div className={styles.header(isMobile)}>
    <div className={styles.title(isMobile)}>{text}</div>
  </div>
);

const styles = {
  header: (isMobile: boolean) => style({
    position: 'relative',
    padding: isMobile ? '6px 0':'9px 0',
    borderBottom: '1px solid black',
  }),

  title: (isMobile: boolean) => style({
    fontSize: isMobile ? 16 : 20,
    margin: isMobile ? 0 : undefined,
  }),
};

export default Header;
